import { Injectable } from '@angular/core';

import { ImportWizardType, MagnetService } from '@mirage-projects/cw-commons';
import { JobPcvizService, UtilsPcvizService } from '@mirage-projects/cw-pcviz-core';

/**
 * This service initializes the job adapters for each type of data import used in the create wizard
 */
@Injectable({ providedIn: 'root' })
export class JobsInitializationService {
    private jobAdapterInitMap = new Map<ImportWizardType, string[]>();

    constructor(
        private jobAdapterService: JobPcvizService,
        private magnetService: MagnetService,
        private utilsPcvizService: UtilsPcvizService,
        private jobPcvizService: JobPcvizService
    ) {}

    /**
     *
     * @param importType type of import to enable jobs
     * @param hasToSelectJob if true, sets the current job with the associated to the import type
     */
    initJobAdapters(importType: ImportWizardType, hasToSelectJob?: boolean): void {
        this.jobAdapterMapInitialization();

        this.disableAllJobAdapter();
        this.jobAdapterService.getJobAdapterService().clearService();

        const jobAdapters = this.jobAdapterInitMap.get(importType) ?? [];
        this.enableJobAdapters(jobAdapters);

        if (hasToSelectJob) {
            this.selectJob(importType);
        }
    }

    private disableAllJobAdapter(): void {
        this.jobAdapterService.getJobAdapterRegistry().setEnabledAllJobAdapter(false);
    }

    private enableJobAdapters(jobAdapters: string[]): void {
        jobAdapters.forEach((id: string) => {
            this.jobAdapterService.getJobAdapterRegistry().setEnabledJobAdapter(id, true);
        });
    }

    private selectJob(value: ImportWizardType): void {
        const jobAdapter = this.jobAdapterService.getJobAdapterRegistry().getImporter(value);
        this.jobAdapterService.getJobAdapterService().setJobAdapter(jobAdapter);
    }

    private jobAdapterMapInitialization(): void {
        this.jobAdapterInitMap
            .set('layer', ['PCU', 'GISU', 'VLU', 'RU', 'M3DVLU', '3MXVLU', 'OBJU'])
            .set('project', ['IZPA'])
            .set('CreateStation', ['CSA'])
            .set('ImportStation', ['SPA'])
            .set('ImportRefs', ['PCU', 'OBJU', 'GISU', 'RU', 'DDU'])
            .set('UpgradeSparse', ['SPA'])
            .set('ImportProject', ['SPA'])
            .set('ImportJobSiteRefs', ['DDU', 'GCP']);

        if (this.magnetService.isSite()) {
            if (this.utilsPcvizService.isTechnicalPreview()) {
                this.jobAdapterInitMap.get('ImportRefs')?.push('BIM', 'CEM');
            } else {
                this.jobAdapterInitMap.set('ImportRefs', ['PCU', 'OBJU', 'GISU']);
            }
            const crp1ScanProjectJobAdapter = this.jobPcvizService.getCrp1ScanProjectJobAdapter();
            this.jobAdapterInitMap.get('ImportStation')?.push(crp1ScanProjectJobAdapter.ID);

            this.jobAdapterService.getJobAdapterRegistry().getInstance().getImporter('GISU').overrideExtensions(['dxf', 'csv']);
        }
    }
}
